import React, { useState } from "react";
import Drinks from "../pages/Drinks";
import Food from "../pages/Food";

export default function FoodDrinkToggle() {
  const [activeTab, setActiveTab] = useState("drink");

  const floatingButtonContainer = {
    position: "absolute",
    left: "50%",
    transform: "translateX(-50%)",
    background: "#fff",
    display: "flex",
    gap: "10px",
    padding: "0.5rem 1rem",
    borderRadius: "9999px",
    boxShadow: "0 4px 12px rgba(0, 0, 0, 0.15)",
    zIndex: 1,
    margin: "90px 0 0 0",
  };

  const buttonBaseStyle = {
    padding: "0.7rem 1.5re",
    border: "none",
    borderRadius: "9999px",
    background: "transparent",
    fontSize: "1rem",
    cursor: "pointer",
    // transition: "background-color 0.1s, color 0.3s",
    color: "#555",
  };

  const activeButtonStyle = {
    backgroundColor: "#931d0a",
    color: "#fff",
    fontWeight: "bold",
  };

  const contentStyle = {
    paddingTop: "100px",
    paddingBottom: "2rem",
    textAlign: "center",
  };

  return (
    <section id="drinks" className="page-section">
      <div
        style={{
          fontFamily: "Arial, sans-serif",
          width: "90%",
          padding: "2rem",
        }}
      >
        {/* Toggle button */}
        <div style={floatingButtonContainer}>
          <button
            style={{
              ...buttonBaseStyle,
              ...(activeTab === "drink" ? activeButtonStyle : {}),
            }}
            onClick={() => setActiveTab("drink")}
          >
            Drinks
          </button>
          <button
            style={{
              ...buttonBaseStyle,
              ...(activeTab === "food" ? activeButtonStyle : {}),
            }}
            onClick={() => setActiveTab("food")}
          >
            Food
          </button>
        </div>

        {/* Toggleable content */}
        <div style={contentStyle}>
          {activeTab === "food" && (
            <section className="tablesection">
              <Food />
            </section>
          )}

          {activeTab === "drink" && (
            <section className="tablesection">
              <Drinks />
            </section>
          )}
        </div>

        {/* Inline keyframes */}
        <style>
          {`
          @keyframes fadeIn {
            from { opacity: 0; transform: translateY(10px); }
            to { opacity: 1; transform: translateY(0); }
          }
        `}
        </style>
      </div>
    </section>
  );
}
